import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function AddressForm({formData, updateFormData}) {

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    // Update the form data in the parent component
    updateFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSaveAddressChange = (event) => {
    const { checked } = event.target;
    updateFormData((prevFormData) => ({
      ...prevFormData,
      saveAddress: checked ? 'yes' : 'no',
    }));
  };

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom style={{color: 'green'}}>
        Shipping address
      </Typography>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
        gap: 3,
        width: '100%',
        '& .MuiFormControl-root': { width: '100%' }
      }}>
        <Box>
          <TextField
            required
            id="firstName"
            name="first_name"
            label="First name"
            fullWidth
            autoComplete="given-name"
            variant="standard"
            onChange={handleInputChange}
            value={formData.first_name}
          />
        </Box>
        <Box>
          <TextField
            required
            id="lastName"
            name="last_name"
            label="Last name"
            fullWidth
            autoComplete="family-name"
            variant="standard"
            onChange={handleInputChange}
            value={formData.last_name}
          />
        </Box>
        <Box>
          <TextField
            required
            id="street"
            name="street"
            label="Street"
            fullWidth
            variant="standard"
            onChange={handleInputChange}
            value={formData.street}
          />
        </Box>
        <Box>
          <TextField
            required
            id="city"
            name="city"
            label="City"
            fullWidth
            autoComplete="shipping address-level2"
            variant="standard"
            onChange={handleInputChange}
            value={formData.city}
          />
        </Box>
        <Box>
          <TextField
            id="state"
            name="state"
            label="State/Province/Region"
            fullWidth
            variant="standard"
            onChange={handleInputChange}
            value={formData.state}
          />
        </Box>
        <Box>
          <TextField
            required
            id="building"
            name="building"
            label="Building"
            fullWidth
            autoComplete="building"
            variant="standard"
            onChange={handleInputChange}
            value={formData.building}
          />
        </Box>
        <Box>
          <TextField
            required
            id="floor"
            name="floor"
            label="Floor"
            fullWidth
            autoComplete="floor"
            variant="standard"
            onChange={handleInputChange}
            value={formData.floor}
          />
        </Box>
        <Box>
          <TextField
            required
            id="phoneNb"
            name="phone_nb"
            label="Phone number"
            fullWidth
            variant="standard"
            onChange={handleInputChange}
            value={formData.phone_nb}
          />
        </Box>
        <Box sx={{ gridColumn: { xs: '1', sm: '1 / -1' } }}>
          <TextField
            id="extraInfo"
            name="extra_info"
            label="Extra info"
            fullWidth
            autoComplete="extra-info"
            variant="standard"
            onChange={handleInputChange}
            value={formData.extra_info}
          />
        </Box>
        <Box sx={{ gridColumn: { xs: '1', sm: '1 / -1' } }}>
          <FormControlLabel
              control={<Checkbox color="secondary" name="saveAddress" />}
              label="Use this address for payment details"
              checked={formData.saveAddress === 'yes'}
              onChange={handleSaveAddressChange}
          />
        </Box>
      </Box>
    </React.Fragment>
  );
}
